import {makeStyles} from '../../theme'

export const useClasses = makeStyles(
  theme => ({
    root: {
      fontSize: '20px',
      lineHeight: '20px',
      fontWeight: 600,
      border: 'none',
      borderRadius: 0,
      textTransform: 'none',
      padding: 0,
      marginRight: theme.spacing(1),
      paddingBottom: 2,
      borderBottom: '2px solid transparent',
      letterSpacing: 'unset',
      '&$selected': {
        backgroundColor: 'inherit',
        borderBottom: `2px solid ${theme.palette.common.black}`,
        '&:hover': {
          backgroundColor: 'inherit',
        },
      },
      '&:hover': {
        backgroundColor: 'inherit',
        color: theme.palette.common.black,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
        whiteSpace: 'nowrap',
      },
    },
    selected: {},
  }),
  {name: 'ToggleButton'},
)
